import { render, staticRenderFns } from "./incomplete_dosage.vue?vue&type=template&id=c264a300&scoped=true&"
import script from "./incomplete_dosage.vue?vue&type=script&lang=js&"
export * from "./incomplete_dosage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c264a300",
  null
  
)

export default component.exports